import { render } from "./MiaAzienda.vue?vue&type=template&id=0a3e6920"
import script from "./MiaAzienda.vue?vue&type=script&lang=js"
export * from "./MiaAzienda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__